<template>
  <div id="app">
    <!--    <img alt="Vue logo" src="./assets/logo.png">-->
    <hm-header
      v-show="path != '/edit-page'"
      :header-obj="headerObj"
    ></hm-header>
    <!-- 路由对应组件的显示 -->
    <router-view />
    <hm-footer v-show="path != '/edit-page'"></hm-footer>
  </div>
</template>

<script>
import HmHeader from "./components/HmHeader";
import HmFooter from "./components/HmFooter";
import Vue from "vue";
import { USER_NAME } from "@/store/mutation-types";
import { mapActions, mapGetters, mapState } from "vuex";
// import MetaInfo from 'vue-meta-info'

export default {
  name: "App",
  components: {
    HmFooter,
    HmHeader,
  },
  metaInfo: {
    title: "低代码开发平台",
    meta: [
      {
        name: "低代码开发平台",
        content: "低代码开发平台",
      },
    ],
    link: [
      {
        rel: "",
        href: "",
      },
    ],
  },
  data() {
    return {
      path: "",
      headerObj: {
        companyName: "低代码开发平台",
        userIcon: require("./assets/hm-logo.png"),
        userName: "admin",
        notifys: [
          {
            title: "系统公告",
            content: "总是想要证明自己的，就没有了投入工作的心态",
            date: "2020/03/28",
          },
          {
            title: "系统公告",
            content: "总是想要证明自己的，就没有了投入工作的心态",
            date: "2020/03/29",
          },
        ],
        menuList: [
          {
            id: 0,
            menuName: "首页",
            path: "/",
          },
          {
            id: 1,
            menuName: "项目",
            path: "/project/list",
          },
          {
            id: 2,
            menuName: "页面",
            path: "/all-page",
          },
          {
            id: 3,
            menuName: "组件",
            path: "/all-component",
          },
          {
            id: 4,
            menuName: "产品",
            path: "/product/index",
          },
        ],
      },
    };
  },
  mounted() {
    this.path = this.$route.path;
  },
  watch: {
    $route(to, from) {
      this.path = to.path;
    },
  },
};
</script>

<style>
#app {
  overflow-x: hidden;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  text-align: center;
  color: #2c3e50;
  background-color: #f5f5f5;
}
</style>
